import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import leaveType from "@/views/module/leave/settings/leaveType.vue";

import leaveApplicationForm from "@/views/module/leave/leaveApplication/leaveApplicationForm.vue";
import leaveApplicationList from "@/views/module/leave/leaveApplication/leaveApplicationList.vue";
import viewLeaveApplication from "@/views/module/leave/leaveApplication/viewLeaveApplication.vue";
import leave from "@/views/module/leave/official/leave.vue";
import leaveList from "@/views/module/leave/official/leaveList.vue";
import leaveRegisterProcess from "@/views/module/leave/leaveRegister/leaveRegisterProcess.vue";
import leaveBalance from "@/views/module/leave/leaveRegister/leaveBalance.vue";
import employeeLeaveProcess from "@/views/module/leave/leaveRegister/employeeLeaveProcess.vue";

import viewLeave from "@/views/module/leave/official/viewLeave.vue";

//Reports
import leaveSummaryReports from "@/views/module/leave/reports/leaveSummaryReports.vue";
import leaveDetailsReports from "@/views/module/leave/reports/leaveDetailsReports.vue";
import leaveEmployeeWiseSummaryReport from "@/views/module/leave/reports/leaveEmployeeWiseSummaryReport.vue";
import leaveEarnedRegisterReports from "@/views/module/leave/reports/leaveEarnedRegisterReports.vue";

export default [
{
    path: "/leave",
    name: "leave",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Leave Management",
    },
    children: [
        {
            path: "leave-type",
            name: "leave-type",
            meta: {
                breadcrumb: ["Leave Management", "Leave Type"],
            },
            component: leaveType,
        },
        {
            path: "add-application",
            name: "add-application",
            meta: {
                breadcrumb: ["Leave Management", "Leave Type"],
            },
            component: leaveApplicationForm,
        },
        {
            path: "application-list",
            name: "application-list",
            meta: {
                breadcrumb: ["Leave Management", "My Leave List"],
            },
            component: leaveApplicationList,
        },
        {
            path: "view-application/:id",
            name: "view-application",
            meta: {
                breadcrumb: ["Leave Management", "View Leave Application"],
            },
            component: viewLeaveApplication,
        },
        {
            path: "add-leave",
            name: "add-leave",
            meta: {
                breadcrumb: ["Leave Management", "Leave"],
            },
            component: leave,
        },
        {
            path: "list",
            name: "list",
            meta: {
                breadcrumb: ["Leave Management", "Leave List"],
            },
            component: leaveList,
        },
        {
            path: "view-leave/:id",
            name: "view-leave",
            meta: {
                breadcrumb: ["Leave Management", "View Leave Application"],
            },
            component: viewLeave,
        },
        {
            path: "leave-process",
            name: "leave-process",
            meta: {
                breadcrumb: ["Leave Management", "Leave Process"],
            },
            component: leaveRegisterProcess,
        },
        {
            path: "leave-details",
            name: "leave-details",
            meta: {
                breadcrumb: ["Leave Management", "Leave Balance"],
            },
            component: leaveBalance,
        },

        {
            path: "employee-leave-process",
            name: "employee-leave-process",
            meta: {
                breadcrumb: ["Leave Management", "Employee Leave Process"],
            },
            component: employeeLeaveProcess,
        },

        
        //Reports
        {
            path: "leave-summary-report",
            name: "leave-summary-report",
            meta: {
                breadcrumb: ["Leave Management", "Leave Summary Report"],
            },
            component: leaveSummaryReports,
        },
        {
            path: "leave-details-report",
            name: "leave-details-report",
            meta: {
                breadcrumb: ["Leave Management", "Leave Details Report"],
            },
            component: leaveDetailsReports,
        },
        {
            path: "employee-wise-summary",
            name: "employee-wise-summary",
            meta: {
                breadcrumb: ["Leave Management", "Employee Wise Summary Report"],
            },
            component: leaveEmployeeWiseSummaryReport,
        },
        {
            path: "leave-earned",
            name: "leave-earned",
            meta: {
                breadcrumb: ["Leave Management", "Leave Earned Register Report"],
            },
            component: leaveEarnedRegisterReports,
        },

    ],
}];
